import { Routes } from '@angular/router';
import { PortalLayoutComponent } from './features/portal/shell/portal-layout/portal-layout.component';
import { PrincipalLayoutComponent } from './core/layout/principal-layout/principal-layout.component';
import { JourneyLayoutComponent } from './core/layout/journey-layout/journey-layout.component';
import { OnboardingLayoutComponent } from './features/solicitud/shared/ui/onboarding-layout/onboarding-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: PrincipalLayoutComponent,
    loadChildren: () =>
      import('./features/marketing/marketing.routes').then(
        (m) => m.MARKETING_ROUTES,
      ),
  },
  // Origination journey of the PDF (3.2): own shell with title, stepper and Ardel footer.
  {
    path: 'solicitud',
    component: OnboardingLayoutComponent,
    loadChildren: () =>
      import('./features/solicitud/solicitud.routes').then(
        (m) => m.ORIGINACION_ROUTES,
      ),
  },
  // Rejection 4.1 renders its own page, like the migration journey.
  {
    path: 'solicitud-prestamo',
    component: JourneyLayoutComponent,
    loadChildren: () =>
      import('./features/solicitud/solicitud.routes').then(
        (m) => m.SOLICITUD_JOURNEY_ROUTES,
      ),
  },
  {
    path: 'solicitud-prestamo',
    component: PrincipalLayoutComponent,
    loadChildren: () =>
      import('./features/solicitud/solicitud.routes').then(
        (m) => m.SOLICITUD_ROUTES,
      ),
  },
  {
    path: 'auth',
    component: PrincipalLayoutComponent,
    canActivate: [guestGuard],
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'portal',
    component: PortalLayoutComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/portal/portal.routes').then((m) => m.PORTAL_ROUTES),
  },
  {
    path: 'migration',
    component: JourneyLayoutComponent,
    loadChildren: () =>
      import('./features/migration/migration.routes').then((m) => m.MIGRATION_ROUTES),
  },
  // Public click of the emails: no layout and no guard (guestGuard would skip the pending step).
  {
    path: 'c',
    loadChildren: () =>
      import('./features/comunicaciones/comunicaciones.routes').then((m) => m.COMUNICACIONES_ROUTES),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];
